export interface Menu {
    categories: MenuItem[];
    imageCategories: MenuItem[];
}

export interface MenuItem {
    label: string;
    values: string[];
    brandValue?: string;
    subItems: MenuItem[];
    isCategoryFilter: boolean;
    isBrandFilter: boolean;
    isStringFilter: boolean;
    hasSubItems: boolean;
    image?: string;
}

export interface BrandsMenu {
    brands: BrandMenuItem[];
}

export interface BrandMenuItem {
    key: string;
    values: string[];
}
